import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_33cef519-6a19-4ccb-ace7-ff1a08bb6e04/artifacts/209s83l6_11%20%285%29.png" 
              alt="Genius Academy" 
              className="h-16 mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed font-semibold mb-2">
              Genius Academy<br />
              Technical and Computer Training Institute
            </p>
            <p className="text-slate-400 text-sm leading-relaxed">
              1:1 Accountability. No Bench-Warmers. Personal tracking for every student.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <Link to="/" className="block text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                Home
              </Link>
              <Link to="/about" className="block text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                About Us
              </Link>
              <Link to="/courses" className="block text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                Our Courses
              </Link>
              <Link to="/notes" className="block text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                Study Notes
              </Link>
              <Link to="/verify" className="block text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                Verify Certificate
              </Link>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:9164998997" className="hover:text-cyan-400 transition-colors block">9164998997</a>
                  <a href="tel:9980147616" className="hover:text-cyan-400 transition-colors block">9980147616</a>
                </div>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <a
                  href="https://maps.app.goo.gl/cXXM4Lyg81THD5xf7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition-colors"
                  data-testid="footer-map-link"
                >
                  2nd floor, Darshan Orchid complex, MSK Mill Rd, Vidya Nagar, Kalaburagi, Karnataka 585103
                </a>
              </li>
            </ul>
          </div>

          {/* Timing */}
          <div>
            <h3 className="text-lg font-bold mb-4">Timing</h3>
            <div className="flex items-start gap-2 text-slate-400 text-sm">
              <Clock size={16} className="mt-1 flex-shrink-0" />
              <div>
                <p>Mon - Sat: 8:00 AM - 8:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-slate-400 text-sm">
          <p
            className="text-xs md:text-sm text-slate-500 leading-relaxed max-w-4xl mx-auto text-center mb-4"
            data-testid="footer-placement-disclaimer"
          >
            <span className="font-semibold text-slate-400">Placement Disclaimer:</span> Placement assistance is provided to
            eligible students. Final job selection depends on the student&apos;s skills, interview performance, employer
            requirements, and available opportunities. Genius Academy does not guarantee employment.
          </p>
          <p className="text-center">&copy; {new Date().getFullYear()} Genius Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;